import { render, staticRenderFns } from "./AddOrderToTransporterSelect.vue?vue&type=template&id=b85b017c&scoped=true&"
import script from "./AddOrderToTransporterSelect.vue?vue&type=script&lang=js&"
export * from "./AddOrderToTransporterSelect.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderToTransporterSelect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddOrderToTransporterSelect.vue?vue&type=style&index=1&id=b85b017c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85b017c",
  null
  
)

/* custom blocks */
import block0 from "./AddOrderToTransporterSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports